import axios from 'axios';
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";

axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-Agent': 'capitalist-js',
};

export default class WebApiClient {
    private host = 'https://capitalist.net';

    constructor(host: string) {
      this.host = host;
    }

    call(path: string, post?: any, query?: any, method?: string) {
      const data: any = Object.assign({}, post, { call: method });

      if ((path.length == 0) || (path.charAt(0) != '/')) path = `/${path}`;

      // return axios.post(this.host + path, data);
      return axios.post(this.host + path,data);
    }
}

export class AxiosWebApiClient {
    private host = 'https://capitalist.net';

    options = {
      maxRedirects: 0,
      validateStatus(status) {
        return status >= 200 && status < 300; // default
      },
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    }

    constructor(host: string) {
      this.host = host;
    }

    call(path: string, post?: any, query?: any, method?: string, config?: any)/*: JQuery.jqXHR */ {
      const data: any = method ? { ...post, call: method } : { ...post };

      if ((path.length == 0) || (path.charAt(0) != '/')) path = `/${path}`;

      let cfg = this.options;
      if (config) cfg = { ...cfg, ...config };

      return httpAxiosApi.post(this.host + path, data, cfg);
    }
}
